var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRemoveLegalDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 4.5,
    stroke: "#0E4C54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7391 12.7356L8.79807 15.6766C8.35463 16.1201 7.77266 16.2569 7.49804 15.9823C7.22356 15.7078 7.36047 15.1255 7.8037 14.6822L10.7447 11.7413L7.80266 8.79921C7.35942 8.35597 7.22251 7.77367 7.497 7.49918C7.77161 7.22456 8.35379 7.3616 8.79703 7.80484L11.7391 10.7469L14.6833 7.80266C15.1265 7.35942 15.7088 7.22251 15.9833 7.497C16.2579 7.77161 16.1209 8.35379 15.6777 8.79703L12.7334 11.7413L15.6766 14.6844C16.1201 15.1279 16.2569 15.7098 15.9823 15.9845C15.7078 16.2589 15.1255 16.122 14.6822 15.6788L11.7391 12.7356Z",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemoveLegalDocument);
export default __webpack_public_path__ + "static/media/icon-remove-legal-document.a3a251957a292c95035afdc02899d3a6.svg";
export { ForwardRef as ReactComponent };